<ng-container *ngIf="getStatus=='download'; else defaultTemplate" >
<div class="invoice-box">

    <h3 class="invoice-title">Invoice Paket Subscription Cepetdapet</h3>

    <div class="row mb-4">
        <div class="col-md-2">
            <div class="logo-box">LOGO</div>
        </div>
        <div class="col-md-5">
            <h5 class="fw-bold mb-1">PT. Sumber Aneka Karya Abadi</h5>
            <p class="mb-1">Jl. Melati Raya No.45, RT 02/RW 03</p>
            <p class="mb-1">Jakarta Selatan, DKI Jakarta</p>
            <p class="mb-1">Indonesia, 12310</p>
        </div>
        <div class="col-md-5">
            <p class="mb-1"><strong>Nomor Telepon:</strong> 081234567890</p>
            <p class="mb-1"><strong>Email:</strong> pt.sumberaneka@email.com</p>
            <p class="mb-1"><strong>NPWP:</strong> 54321081785542123321</p>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-md-6">
            <p><strong>No. Invoice:</strong> #GHKDIEYJ4975</p>
            <p><strong>ID Pelanggan:</strong> #76354873592879408</p>
        </div>
        <div class="col-md-6 text-md-end">
            <p><strong>Tanggal:</strong> 10 Jun 2025</p>
        </div>
    </div>

    <div class="table-responsive mb-4">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th style="width:5%">No</th>
                    <th style="width:20%">Produk</th>
                    <th style="width:20%">Masa Berlaku</th>
                    <th style="width:30%">Deskripsi</th>
                    <th style="width:5%">Jml</th>
                    <th style="width:20%">Harga</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Profesional</td>
                    <td>10 Jun 2025 - 10 Jul 2025</td>
                    <td>
                        <ul class="mb-0">
                            <li>Partisipasi RFQ: 20</li>
                            <li>Analisa Pasar: 2</li>
                            <li>Produk Aktif: 10</li>
                            <li>Notifikasi Kecocokan RFQ: 5</li>
                            <li>Company Tag: 5</li>
                            <li>Jumlah User: 2</li>
                        </ul>
                    </td>
                    <td>1</td>
                    <td>IDR 399,000</td>
                </tr>

                <tr>
                    <td>2</td>
                    <td>Paket Tambahan: Analisa Pasar 150</td>
                    <td>10 Jun 2025 - 10 Jul 2025</td>
                    <td>Tambahan 150 kuota analisa pasar</td>
                    <td>1</td>
                    <td>IDR 199,000</td>
                </tr>

                <tr>
                    <td>3</td>
                    <td>Paket Tambahan: Jumlah User 5</td>
                    <td>10 Jun 2025 - 10 Jul 2025</td>
                    <td>Tambahan 5 kuota jumlah user</td>
                    <td>1</td>
                    <td>IDR 299,000</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="dashed-box mb-4">
        <div class="row">
            <div class="col-md-4"><strong>No. Proforma Invoice</strong></div>
            <div class="col-md-8">#HJG8745JI845</div>

            <div class="col-md-4"><strong>Metode Pembayaran</strong></div>
            <div class="col-md-8">Transfer Bank BCA</div>

            <div class="col-md-4"><strong>Nomor Rekening</strong></div>
            <div class="col-md-8">1234 5678 90 (PT Cepetdapet Company)</div>
        </div>
    </div>

    <div class="row justify-content-end">
        <div class="col-md-5">
            <div class="summary-box">
                <div class="d-flex justify-content-between total-row">
                    <span>Subtotal</span>
                    <span>IDR 897,000</span>
                </div>
                <div class="d-flex justify-content-between total-row">
                    <span>Pajak (10%)</span>
                    <span>IDR 89,700</span>
                </div>
                <div class="d-flex justify-content-between total-row">
                    <span>Voucher</span>
                    <span>(- IDR 200,000)</span>
                </div>
                <hr>
                <div class="d-flex justify-content-between total-final">
                    <span>Total Pembayaran</span>
                    <span>IDR 786,700</span>
                </div>
            </div>
        </div>
    </div>

</div>
</ng-container>
<ng-template #defaultTemplate>



<!-- Loading State -->
<div *ngIf="loading" class="divsubscription bg-white px-3 py-5">
  <div>
    <div class="text-center pt-5 pb-5">
      <div class="loader loader--style8" title="7">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
          </rect>
        </svg>
      </div>
    </div>  
  </div>   
</div>



<!-- Cart Review Content -->
<div *ngIf="!loading" class="">
  <div class="container pb-5">

    <!-- Breadcrumb -->
    <div class="mb-3">
      <app-breadcrumb 
        returnAction="/dashboard" 
        [breadcrumbs]="[
            { label: 'Company Management', url: '/setting/company-management' },
            { label: 'Pesanan' }
        ]"
      >
      </app-breadcrumb>
    </div> 

    <ng-container *ngIf="getStatus==''">


    
            <div *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PAYMENTRECEIVED' && !loading" class="alert alert-success" style="color:#0a3622;border-color:#75b798;background-color: #d1e7dd;font-size: 14px;">

                Pembayaran Anda telah berhasil dikonfirmasi dan Invoice telah diterbitkan. Selamat menikmati fitur premium Anda.

            </div>

            <div *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='EXPIRED' && !loading" class="alert alert-danger" style="color:#58151c;border-color:#ea868f;background-color: #f8d7da;font-size: 14px;">

                Pembayaran Anda telah melewati batas waktu yang ditentukan. Transaksi Anda otomatis telah dibatalkan pada {{proformaInvoiceDetail?.proformaInvoiceExpiredDate | date:'d MMM y HH:mm'}}. Silakan membuat pesanan ulang atau <a href="/contact-us">hubungi kami</a> jika memerlukan bantuan lebih lanjut.

            </div>

            <div *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PENDINGAPPROVAL' && !loading" class="alert alert-info" style="background-color: #fff3cd; border-color: #ffda6a; color: #664d03;  font-size: 14px;">
                Terima kasih atas pembayaran Anda. Paket Anda akan segera kami aktifkan setelah pembayaran dikonfirmasi. Proses ini biasanya memerlukan 1-3 hari kerja. Jika paket Anda tidak aktif dalam 3 hari kerja, silakan <a href="/contact-us">hubungi kami</a>.
            </div>            
            
    </ng-container>

    <!-- Header -->
    <div class="card border-0 mb-3">
      <div class="row">
        <div class="col-sm-12">
          <div class="cd-title" *ngIf="getType==''">{{ getStatus=='' ? 'Pesanan': 'Invoice'}}</div>
          <div class="cd-title" *ngIf="getType!==''">{{getType=='inv'?'Invoice': getType=='ppo'?'Proforma Invoice': ''}}</div>
        </div>
      </div>
    </div>

    <!-- Stepper Navigation -->
    <div class="card border-0 mb-3">
      <div class="cd-content px-3 py-2">
        <div class="divsubscription pb-3" *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
          <div class="row g-0 justify-content-center pb-3">
            <div class="col-12">
              <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">
                <!-- Step 1 -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2  active-link">
                  <a class="nav-link mn-color border-bottom border1 border-2 " (click)="goBackToProducts()" style="cursor: pointer;">
                    <i class="fas fa-shopping-bag me-2"></i>Langkah 1 (Pilih Paket)
                  </a>
                </li>

                <!-- Step 2 (Current) -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2 active-link">
                  <a class="nav-link mn-color border-bottom border1 border-2">
                    <i class="fas fa-list me-2"></i>Langkah 2 (Pesanan)
                  </a>
                </li>

                <!-- Step 3 -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2 active-link">
                  <a class="nav-link mn-color border-bottom border1 border-2">
                    <i class="fas fa-credit-card me-2"></i>Langkah 3 (Konfirmasi Pesanan)
                  </a>
                </li>
              </nav>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="mainContent" *ngIf="billingDetail">


            <!-- Loading Spinner -->
            <div *ngIf="loading" class="loading-spinner">
                <p>Loading billing details...</p>
            </div>

            <!-- Error Message -->
            <div *ngIf="error && !loading" class="alert alert-danger">
                {{ error }}
            </div>
            <div *ngIf="billingDetail===null && !loading" class="alert alert-warning">
                Detail tagihan gagal dimuat. Silakan coba lagi beberapa saat.
              </div>

            <div *ngIf="billingDetail && !loading" class="mb-5">
              

              <div class="row align-items-center">
                <div class="col-9">
                  <h2 class="section-title cdc1 fw-bold my-3">{{companyName}}</h2>
                </div>
                <div class="col-3 text-end">

                  <ng-container *ngIf="getStatus==''">

                  <div class="badge bg-warning" style="color: #e77f08 !important;background-color: #ffecc7 !important;" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PENDINGAPPROVAL'">Dalam Proses</div>

                  <div class="badge bg-success" style="background-color: #d9f3e4 !important;color:#2e876b !important;" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PAYMENTRECEIVED'">Selesai</div>

                  <div class="badge bg-info" style="background-color: #d7eeff !important;color:#4797d0 !important;" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='OPEN'">Menunggu Pembayaran</div>

                  <div class="badge bg-danger" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='EXPIRED'" style="color: #ea3d3d !important; background-color: #fbe2e2 !important;">Kadaluarsa</div>
                  
                  </ng-container>
                  
                </div>
              </div>




              <ng-container *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
              <div class="p-2 divAddress">
                <div class="row">
                  <div class="col-sm-6">
                    <p>{{billingDetail.billingAddress}}</p>
                    <p>{{billingDetail.billingProvince}}</p>
                    <p>{{billingDetail.billingCity}}</p>
                    <p>{{billingDetail.billingCountry}} {{billingDetail.billingPostalCode}}</p>
                  </div>
                  <div class="col-sm-6">
                    <p>{{billingDetail.billingEmail}}</p>
                    <p>{{billingDetail.billingPhone}}</p>
                    <p>{{billingDetail.billingTaxId}}</p>
                  </div>
                </div>
              </div>
              </ng-container>

              <ng-container   *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PENDINGAPPROVAL' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='EXPIRED' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PAYMENTRECEIVED'">

                <div class="row">
                  <div class="col-sm-7">
                    <div class="p-2 divAddress">
                      <div class="row">
                        <div class="col-sm-6">
                          <p>{{billingDetail.billingAddress}}</p>
                          <p>{{billingDetail.billingProvince}}</p>
                          <p>{{billingDetail.billingCity}}</p>
                          <p>{{billingDetail.billingCountry}} {{billingDetail.billingPostalCode}}</p>
                        </div>
                        <div class="col-sm-6">
                          <p>{{billingDetail.billingEmail}}</p>
                          <p>{{billingDetail.billingPhone}}</p>
                          <p>{{billingDetail.billingTaxId}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">

                    <div class="p-2 divInvoiceStatus" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()!='PAYMENTRECEIVED'">
                      <div class="row">
                        <div class="col-sm-6">
                          <p><b>No. Proforma Invoice</b></p>
                          <p>{{proformaInvoiceDetail?.proformaInvoiceNo}}</p>
                          <p><b>ID Pelanggan</b></p>
                          <p>#{{formatDisplayId(companyId)}}</p>

                        </div>
                        <div class="col-sm-6">
                          <p><b>Tanggal Proforma Invoice</b></p>
                          <p>{{proformaInvoiceDetail?.proformaInvoiceDate | date:'d MMM y'}}</p>
                          <p><b>Bayar Sebelum</b></p>
                          <p>{{ proformaInvoiceDetail?.proformaInvoiceExpiredDate | date:'d MMM y HH:mm'}}</p>

                        </div>
                      </div>
                    </div>

                    <div class="p-2 divInvoiceStatus"  *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PAYMENTRECEIVED'">
                      <div class="row">
                        <div class="col-sm-12">
                          <p><b>No. Proforma Invoice</b></p>
                          <p>{{proformaInvoiceDetail?.proformaInvoiceNo}}</p>
                          <p><b>ID Pelanggan</b></p>
                          <p>{{formatDisplayId(companyId)}}</p>
                          <p><b>Tanggal Proforma Invoice</b></p>
                          <p>{{proformaInvoiceDetail?.proformaInvoiceDate | date:'d MMM y'}}</p>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>


              </ng-container>


            </div>


            <div class="card border-0 mb-4">
                <div class="card-header" style="background-color: #74bec1; color: white; padding: 15px 20px; border-radius: 8px 8px 0 0;">
                    <h6 class="mb-0 fw-bold">Paket Dipilih</h6>
                </div>
                <div class="cd-rfq-list-quote">
                    <div class="mb-2">
                        <div class="table-responsive mb-0" *ngIf="billingDetail?.billingItem && billingDetail.billingItem.length > 0">
                            <table class="table vlistqrfq mb-0 align-middle border-radius-0" cellpadding="10">
                                <thead>
                                    <tr style="background-color: #e8e8e8; border-bottom: 1px solid #006572;">
                                        <th scope="col" style="width: 8%; color: #333;">No.</th>
                                        <th scope="col" style="color: #333;">Produk</th>
                                        <th scope="col" style="color: #333;">Deskripsi</th>
                                        <th scope="col" class="text-center" style="width: 10%; color: #333;">Jumlah</th>
                                        <th scope="col" class="text-center" style="width: 15%; color: #333;">Harga</th>
                                    </tr>
                                </thead>
                                <tbody>



                                    <!-- Cart Items -->
                                    <tr *ngFor="let item of billingDetail?.billingItem; let i = index">
                                        <td class="align-middle text-center">
                                            <strong style="color: #006572; font-size: 16px;">{{ i + 1 }}</strong>
                                        </td>
                                        <td class="align-middle">
                                            <strong style="color: #006572;">{{ item?.offeringLabel }}</strong>
                                        </td>
                                        <td class="align-middle">
                                            <div class="mb-0 ps-3" style="color: #006572;" *ngIf="item?.subscriptionFeatures && item.subscriptionFeatures.length > 0">
                                              <ul>
                                                <li *ngFor="let feature of item?.subscriptionFeatures">
                                                {{ feature }}
                                                </li>
                                              </ul>    
                                              
                                            </div>
                                        </td>
                                        <td class="align-middle text-center">
                                            {{ item?.purchasedQty }}
                                        </td>
                                        <td class="align-middle text-end">
                                            IDR {{ item?.price | number:'1.0-0' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Summary Section Below Table -->
            <div class="row mb-4">
                <div class="col-md-6">

                    <div class="p-2 divTransferDetail"  *ngIf="getStatus==''">
                      <div class="row">
                        <div class="col-6">
                          <p>
                            <b>No. Proforma Invoice</b>
                          </p>
                          <p>
                            <b>Metode Pembayaran</b>
                          </p>
                          <p>
                            <b>Nomor Rekening</b>
                          </p>
                        </div>


                        <div class="col-6">
                          <p>{{proformaInvoiceDetail?.proformaInvoiceNo}}</p>
                          <p>Transfer Bank BCA</p>
                          <p>1234 5678 90 (PT Cepetdapet Company)</p>
                        </div>
                      </div>
                    </div>


                </div>
                <div class="col-md-1"></div>
                <div class="col-md-5">
                    <div style="font-size: 14px;">
                        <div class="row mb-3">
                            <div class="col-6">
                                <span class="cdc1">Subtotal</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                                IDR {{ getTotalPrice() | number:'1.0-0' }}
                            </div>
                        </div>

                        <div class="row mb-3" *ngIf="billingDetail?.billingTax">
                            <div class="col-6">
                                <span class="cdc1">Pajak</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                               IDR {{ billingDetail?.billingTax | number:'1.0-0' }}
                            </div>
                        </div>

                        <div class="row" style="border-top: 2px solid #ddd; padding-top: 15px;">
                            <div class="col-6">
                                <span style="font-weight: bold; font-size: 16px;" class="cdc1">Total</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                                <strong>IDR {{ getGrandTotal() | number:'1.0-0' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="getStatus==''">

            <div class="card-header" style="background-color: #74bec1; color: white; padding: 15px 20px; border-radius: 8px 8px 0 0;" *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
              <h6 class="mb-0 fw-bold">Pilih Metode Pembayaran</h6>
            </div>
            <div class="cd-rfq-list-quote" *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
              <div class=" vlistqrfq mb-0 align-middle border-radius-0">
                <tbody>
                  <tr>
                    <td>
                      <div class="w-100 p-3">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="true" checked>
                          <label class="form-check-label" for="inlineRadio1">Transfer Bank BCA</label>
                          <label class="form-check-label" for="inlineRadio1">1234567890 (PT Cepetdapet Company)</label>
                        </div>  
                      </div>

                    </td>
                  </tr>
                </tbody>
              
              </div>
            </div>






            <div class="divPaymentInfo">
              <div class="alert alert-warning mt-2 mb-4 p-1 fw-bold" *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
                <!-- <small>
                  Harap unggah bukti pembayaran Anda dalam waktu maksimal 24 jam setelah transaksi dilakukan.
                </small> -->
                <small>
                  Harap unggah bukti pembayaran Anda setelah transaksi dilakukan.
                </small>                
              </div>
            </div>

            <div>
              <!-- ngb-accordion auto expland open -->
                            <ngb-accordion #acc="ngbAccordion" class="DivAccordion"  activeIds="panel-0">
                                <ngb-panel class="div-accordion-title" id="panel-0">
                                    <ng-template ngbPanelTitle>
                                        <div class="accordion-title">
                                          <b>Instruksi Pembayaran</b> 
                                        </div>    
                                    </ng-template>
                                    <ng-template ngbPanelContent>

                                      <div class="divPaymentInstruction">

                                        <div class="section-title">i. Transfer Pembayaran</div>
                                        <div class="content py-2">
                                          <p>Silakan lakukan transfer pembayaran ke rekening berikut sebesar <i>jumlah tagihan Anda</i></p>

                                          <div class="row">
                                            <div class="col-3">Bank Tujuan</div>
                                            <div class="col-auto">:</div>
                                            <div class="col-auto">
                                              <font>{{proformaInvoiceDetail?.paymentMethod == 'WIRETRANSFER' ? 'Bank BCA' : ''}}</font>
                                              <i *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">Sesuai metode pilihan</i>
                                            </div>
                                          </div>

                                          <div class="row">
                                            <div class="col-3">Nomor Rekening</div>
                                            <div class="col-auto">:</div>
                                            <div class="col-auto"> 
                                              <font>{{proformaInvoiceDetail?.paymentMethod == 'WIRETRANSFER' ? '1234567890' : ''}}</font>
                                              <i *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">Sesuai metode pilihan</i>
                                            </div>
                                          </div>

                                          <div class="row">
                                            <div class="col-3">Nama Rekening</div>
                                            <div class="col-auto">:</div>
                                            <div class="col-auto">PT Cepetdapet Company</div>
                                          </div>

                                          <div class="row">
                                            <div class="col-3">Berita Transfer</div>
                                            <div class="col-auto">:</div>
                                            <div class="col-auto">Pembayaran 
                                              
                                             <font>{{proformaInvoiceDetail?.proformaInvoiceNo}}</font>
                                              <font *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">[No.Proforma PO]</font>                                            
                                            </div>
                                          </div>

                                          <br>
                                        </div>

                                        <div class="section-title">ii. Langkah Selanjutnya</div>
                                        <div class="content py-2">
                                          <ol>
                                            <li><b>Transfer</b> nominal yang tertera secara tepat.</li>
                                            <li><b>Isi berita transfer</b> sesuai instruksi / sesuai nomor Proforma Invoice Anda agar verifikasi lebih cepat.</li>
                                            <li><b>Unggah</b> bukti pembayaran dan lengkapi detail pembayaran pada formulir yang tersedia.</li>
                                            <li><b>Tunggu</b> proses aktivasi otomatis maksimal 3 hari kerja. 
                                              <u><a href="/contact-us">Hubungi kami</a></u> jika belum aktif setelah 3 hari kerja.
                                            </li>
                                          </ol>
                                        </div>
                                      </div>


                                      

                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
            </div>


            <div  id="goToPayment">

            <!-- Payment Method Section -->
             <div class="payment-content my-4 mb-2">
                <div class="payment-method-section" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'  || proformaInvoiceDetail?.proformaInvoiceStatus=='PENDINGAPPROVAL'">
                <h2 class="section-title">Pilih Metode Pembayaran</h2>
                <div class="payment-options">
                    <div class="payment-option selected">
                    <!-- <input type="radio" id="bca" name="payment" value="bca" checked> -->
                    <label for="bca" class="payment-label">
                        <span class="radio-circle"></span>
                        <span class="payment-name">Transfer Bank BCA</span>
                        <span class="payment-details">BCA - 1234567890 (PT. Cepetdapet Company)</span>
                    </label>
                    </div>

                    <div class="py-2">

                      <!-- status open -->
                      <div id="paymentUpload" class=""  *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'  || proformaInvoiceDetail?.proformaInvoiceStatus=='PENDINGAPPROVAL'">
                          <div class="row">
                              <div class="col-sm-12">
                                  <!-- Upload Error Message -->
                                  <div *ngIf="uploadError" class="alert alert-danger mb-3">
                                      {{ uploadError }}
                                  </div>

                                  <!-- File Input -->
                                  <div class="mb-3">
                                      <label for="paymentFileInput" class="form-label">Select Payment Receipt (Image only, Max 8MB)</label>
                                      <input 
                                          type="file" 
                                          class="form-control" 
                                          id="paymentFileInput"
                                          accept="image/*"
                                          (change)="onFileSelected($event)"
                                          [disabled]="uploadingFile"
                                      />
                                      <small class="text-muted d-block mt-2">
                                          Supported formats: JPG, PNG, GIF, WebP
                                      </small>
                                      <!-- <small class="text-muted d-block">
                                          Selected file: {{ selectedFile ? selectedFile.name : 'None' }}
                                      </small> -->
                                  </div>

                                  <div class="actions">
                                      <button 
                                          class="btn btn-primary"
                                          (click)="onUploadPaymentReceipt()"
                                          [disabled]="uploadingFile || !selectedFile || uploadError"
                                      >
                                          <span *ngIf="!uploadingFile">Upload bukti Pembayaran</span>
                                          <span *ngIf="uploadingFile">
                                              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                              Uploading...
                                          </span>
                                      </button>
                                      <!-- <button class="btn btn-secondary" (click)="goBackToSubscriptions()" [disabled]="uploadingFile">
                                          Kembali
                                      </button>                  -->
                                  </div>

                              </div>
                          </div>



                      </div>



                    </div>


                </div>
                </div>
              </div>
            
            </div>

            <div class="divPaymentInfo">
              <div class="alert alert-warning mt-2 mb-4 p-1 fw-bold" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'">
                <!-- <small>
                  Jatuh tempo pada {{proformaInvoiceDetail?.proformaInvoiceExpiredDate | date:'d MMM y HH:mm'}}. Harap unggah bukti pembayaran Anda dalam waktu maksimal 24 jam setelah transaksi dilakukan.
                </small> -->
                <small>
                  Harap unggah bukti pembayaran Anda setelah transaksi dilakukan. Jatuh tempo pada {{proformaInvoiceDetail?.proformaInvoiceExpiredDate | date:'d MMM y HH:mm'}}. 
                </small>                
              </div>
            </div>



            <div class="mb-4">
              <!-- ngb-accordion auto expland open -->
              <!-- <ngb-accordion #acc="ngbAccordion" class="DivAccordion" id="historyPayment" [activeIds]="(proformaInvoiceDetail?.paymentImageUrl?.length ?? 0) > 0 ? ['panel-1'] : []"> -->
              <ngb-accordion #acc="ngbAccordion" class="DivAccordion" id="historyPayment" [activeIds]="(proformaInvoiceDetail?.paymentImageUrl?.length ?? 0) > 0 ? ['panel-1'] : []"  *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus">
                  <ngb-panel class="div-accordion-title" id="panel-1">
                      <ng-template ngbPanelTitle>
                          <div class="accordion-title">
                            <b>Riwayat Pembayaran</b> 
                          </div>    
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <ng-container *ngIf="(proformaInvoiceDetail?.paymentImageUrl?.length ?? 0) > 0; else noPaymentHistory">
                          <div class="cd-rfq-list-quote">
                          <div class="table-responsive">
                            <table class="table vlistqrfq mb-0 align-middle border-radius-0">
                              <thead>
                                <tr style="background-color: #e8e8e8; border-bottom: 1px solid #006572;">
                                  <th style="color: #333;">Tanggal Pembayaran</th>
                                  <!-- <th style="width:30%;color: #333;">Nilai Pembayaran</th> -->
                                  <th style="color: #333;">Pratinjau Bukti Pembayaran</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let payment of proformaInvoiceDetail?.paymentImageUrl">
                                  <td>{{ payment.paymentDate | date: 'dd MMM yyyy HH:mm' }}</td>
                                  <!-- <td>{{ payment.value | currency: 'IDR': 'symbol': '1.0-0' }}</td> -->
                                  <td>
                                    <a href="#" class="btn btn-sm btn-outline-primary" (click)="openPaymentGallery($event, payment.imageUrl)">
                                      <img [src]="payment.imageUrl"  style="max-width: 100px;" class="img-fluid">
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          </div>
                          <!-- Hidden Lightgallery for Payment Images -->
                          <lightgallery *ngIf="proformaInvoiceDetail?.paymentImageUrl?.length! > 0" [settings]="paymentGallerySettings" id="paymentGallery" [onInit]="onInitPaymentGallery" style="display: none;">
                            <a *ngFor="let payment of proformaInvoiceDetail?.paymentImageUrl!" [attr.href]="payment.imageUrl"></a>
                          </lightgallery>
                        </ng-container>
                        <ng-template #noPaymentHistory>
                          <div class="w-100 text-center">
                            <small class="text-danger">
                              Anda tidak memiliki riwayat pembayaran saat ini.
                            </small>
                          </div>
                        </ng-template>

                      </ng-template>
                  </ngb-panel>
              </ngb-accordion>
            </div>


            </ng-container>


          <div class="d-none">



            <!-- Billing Details Section -->
            <div *ngIf="billingDetail && !loading" class="payment-content">
                <!-- Company Information Section -->
        
                <div class="company-info-section">
                <h2 class="section-title cdc1">{{companyName}}</h2>
                <div class="company-details">
                    <div class="company-left">
                    <div class="info-block">
                        <h3 class="block-title">Kantor Pusat</h3>
                        <p>Jl. Melati Raya No. 45, RT 02/RW 03</p>
                        <p>Jakarta Selatan</p>
                        <p>DKI Jakarta, 12310</p>
                        <p>Indonesia</p>
                    </div>
                    </div>
                    <div class="company-right">
                    <div class="info-block">
                        <div class="info-row-compact">
                        <label>Nomor Telepon</label>
                        <span>{{ billingDetail?.billingPhone }}</span>
                        </div>
                        <div class="info-row-compact">
                        <label>Email</label>
                        <span>{{ billingDetail?.billingEmail }}</span>
                        </div>
                        <div class="info-row-compact">
                        <label>NPWP</label>
                        <span>{{ billingDetail?.billingTaxId }}</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <!-- Selected Packages Section -->
                <div class="packages-section">
                <h2 class="section-title">Paket Dipilih</h2>
                <div class="packages-table">
                    <div class="table-header">
                    <div class="col-no">No.</div>
                    <div class="col-product">Produk</div>
                    <div class="col-description">Deskripsi</div>
                    <div class="col-qty">Jumlah</div>
                    <div class="col-price">Harga</div>
                    </div>
                    <div class="table-body" *ngIf="billingDetail?.billingItem && billingDetail.billingItem.length > 0">
                    <div class="table-row" *ngFor="let item of billingDetail?.billingItem; let i = index">
                        <div class="col-no">{{ i + 1 }}</div>
                        <div class="col-product">{{ item?.offeringLabel }}</div>
                        <div class="col-description">
                        <ul class="description-list" *ngIf="item?.subscriptionFeatures && item.subscriptionFeatures.length > 0">
                            <li *ngFor="let feature of item?.subscriptionFeatures">
                            {{ feature }}
                            </li>
                        </ul>
                        </div>
                        <div class="col-qty text-end">{{ item?.purchasedQty }}</div>
                        <div class="col-price text-end">IDR {{ item?.price | number:'1.0-0' }}</div>
                    </div>
                    </div>
                </div>
                </div>

                <!-- Voucher Section -->
                <!-- <div class="voucher-section">
                <h3 class="section-label">Pilih Voucher</h3>
                <div class="voucher-input">
                    <select class="voucher-select">
                    <option>-- Pilih Voucher --</option>
                    <option selected>Voucher IDR 200,000</option>
                    </select>
                </div>
                </div> -->

                <!-- Price Summary Section -->
                <div class="price-summary-section">
                <div class="summary-item">
                    <span class="summary-label">Subtotal</span>
                    <span class="summary-value text-end">IDR {{ getTotalPrice() | number:'1.0-0' }}</span>
                </div>
                <div class="summary-item" *ngIf="billingDetail?.billingTax">
                    <span class="summary-label">Pajak</span>
                    <span class="summary-value text-end">IDR {{ billingDetail?.billingTax | number:'1.0-0' }}</span>
                </div>
                <!-- <div class="summary-item">
                    <span class="summary-label">Voucher</span>
                    <span class="summary-value voucher-discount">(- IDR 200,000)</span>
                </div> -->
                <div class="summary-item total">
                    <span class="summary-label">Total</span>
                    <span class="summary-value text-end">IDR {{ getGrandTotal() | number:'1.0-0' }}</span>
                </div>
                </div>





                <!-- Payment Method Section -->
                <div class="payment-method-section" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'">
                <h2 class="section-title">Pilih Metode Pembayaran</h2>
                <div class="payment-options">
                    <div class="payment-option selected">
                    <!-- <input type="radio" id="bca" name="payment" value="bca" checked> -->
                    <label for="bca" class="payment-label">
                        <span class="radio-circle"></span>
                        <span class="payment-name">Transfer Bank BCA</span>
                        <span class="payment-details">BCA - 1234567890 (PT. Cepetdapet Company)</span>
                    </label>
                    </div>
                    <!-- <div class="payment-option">
                    <input type="radio" id="bni" name="payment" value="bni">
                    <label for="bni" class="payment-label">
                        <span class="radio-circle"></span>
                        <span class="payment-name">Transfer Bank BNI</span>
                        <span class="payment-details">BNI - 0987654321 (PT. Cepetdapet Company)</span>
                    </label>
                    </div>
                    <div class="payment-option">
                    <input type="radio" id="mandiri" name="payment" value="mandiri">
                    <label for="mandiri" class="payment-label">
                        <span class="radio-circle"></span>
                        <span class="payment-name">Transfer Bank Mandiri</span>
                        <span class="payment-details">Mandiri - 6789054321 (PT. Cepetdapet Company)</span>
                    </label>
                    </div> -->
                </div>
                </div>




                
                <!-- Warning Message -->
                <div class="warning-message" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'">
                <!-- <span class="warning-icon">⚠</span>
                Harap tunggu bukti pembayaran Anda dalam waktu maksimal 24 jam setelah transaksi dilakukan.
                </div> -->
                <span class="warning-icon">⚠</span>
                Harap tunggu bukti pembayaran Anda setelah transaksi dilakukan.
                </div>
                <!-- status null -->
                <div class="actions"  *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">
                <button class="btn btn-primary" (click)="modalConfirmPayment()" [disabled]="loadingSubmit">
                    Konfirmasi
                </button>
                <button class="btn btn-secondary" (click)="goBackToSubscriptions()">
                    Kembali
                </button>
                </div>


                <!-- status open -->
                <div id="paymentUpload" class=""  *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN'">
                    <div class="row">
                        <div class="col-sm-12">
                            <!-- Upload Error Message -->
                            <div *ngIf="uploadError" class="alert alert-danger mb-3">
                                {{ uploadError }}
                            </div>

                            <!-- File Input -->
                            <div class="mb-3">
                                <label for="paymentFileInput" class="form-label">Select Payment Receipt (Image only, Max 8MB)</label>
                                <input 
                                    type="file" 
                                    class="form-control" 
                                    id="paymentFileInput"
                                    accept="image/*"
                                    (change)="onFileSelected($event)"
                                    [disabled]="uploadingFile"
                                />
                                <small class="text-muted d-block mt-2">
                                    Supported formats: JPG, PNG, GIF, WebP
                                </small>
                                <!-- <small class="text-muted d-block">
                                    Selected file: {{ selectedFile ? selectedFile.name : 'None' }}
                                </small> -->
                            </div>

                            <div class="actions">
                                <button 
                                    class="btn btn-primary"
                                    (click)="onUploadPaymentReceipt()"
                                    [disabled]="uploadingFile || !selectedFile || uploadError"
                                >
                                    <span *ngIf="!uploadingFile">Upload bukti Pembayaran</span>
                                    <span *ngIf="uploadingFile">
                                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Uploading...
                                    </span>
                                </button>
                                <button class="btn btn-secondary" (click)="goBackToSubscriptions()" [disabled]="uploadingFile">
                                    Kembali
                                </button>                 
                            </div>

                        </div>
                    </div>



                </div>

                <!-- status expired -->
                <div class="actions"  *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='EXPIRED' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PAYMENTRECEIVED' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PENDINGAPPROVAL' ">

                <button class="btn btn-secondary" (click)="goBackToSubscriptions()">
                    Kembali
                </button>
                </div>
            </div>

          </div>

        </div>


      </div>
    </div>



  </div>
</div>


<div class="fixed-bottom">
  <div class="bg-white pt-3 pb-3">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-sm-6">

          <a *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus" class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/subscription-products">
              Kembali
          </a>

          <a *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='OPEN' || proformaInvoiceDetail?.proformaInvoiceStatus?.trim()=='PENDINGAPPROVAL'" class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/billing-list">
              Kembali
          </a>

          <a *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim() =='EXPIRED'" class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/billing-list">
              Kembali
          </a>

          <ng-container *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim() =='PAYMENTRECEIVED'">

          <a *ngIf="getStatus==''" class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/billing-list">
              Kembali
          </a>            
          <a *ngIf="getStatus!==''" class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/billing-list/detail/{{offerId}}">
              Kembali
          </a>      

          </ng-container>


        </div>



        <div class="col-sm-6">
          <div class="d-flex justify-content-end" *ngIf="!proformaInvoiceDetail?.proformaInvoiceStatus">

                <button class="btn cdbtn2 ms-3 ps-4 pe-4" (click)="modalConfirmPayment()" [disabled]="loadingSubmit">
                  <span class="px-3">Submit Order</span>
                </button>
            
          </div>

          <div class="d-flex justify-content-end" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus=='OPEN' || proformaInvoiceDetail?.proformaInvoiceStatus=='PENDINGAPPROVAL'">
            <div class="">
              <a href="/billing-list/detail/{{offerId}}#goToPayment" class="btn cdbtn2 px-3">Submit Bukti Bayar</a>
            </div>
          </div>


          <div class="d-flex justify-content-end" *ngIf="proformaInvoiceDetail?.proformaInvoiceStatus?.trim() =='PAYMENTRECEIVED'">

            <a href="/billing-list/download/{{offerId}}" target="_blank" class="btn cdbtn3 px-3 mx-3">
                Download Invoice
            </a>
            <a *ngIf="getType!='ppo'" href="/billing-list/detail/{{offerId}}?type=ppo" class="btn cdbtn2">
              <span class="px-3">Lihat Proforma</span>
            </a>
            <a *ngIf="getType=='ppo'" href="/billing-list/detail/{{offerId}}" class="btn cdbtn2">
              <span class="px-3">Lihat Invoice</span>
            </a>
          </div>


          
        </div>
      </div>
    </div>
  </div>
</div>





</ng-template>


















































